import log from 'loglevel'
import type { LogLevelDesc } from 'loglevel'
import prefix from 'loglevel-plugin-prefix'

const logger = () => {
	// trace/debug/info/warn/error 단계로 진행되며, silent이면 모든 로그가 표시되지 않습니다.
	// 환경변수가 string 타입이므로 LogLevelDesc로 타입 단언합니다.
	log.setLevel(import.meta.env.VITE_APP_DEBUG_LEVEL as LogLevelDesc)

	prefix.reg(log)
	prefix.apply(log, {
		timestampFormatter(date) {
			// 시:분:초:밀리세컨드 포맷
			return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*!/, '$1') + ':' + date.getMilliseconds()
		},
		format(level, name, timestamp) {
			return `[${timestamp}][${level}]`
		},
	})
}

export default defineNuxtPlugin(() => {
	logger()
	return {
		provide: {
			log,
		},
	}
})